/**
 * First tests started from the home page in this browser before 4 November 2026 (slug → where the test lives in
 * the app). Their public report shows the author's actions there. Nothing new is saved: tests no longer get a
 * public page. Browser storage can be missing or blocked: every access is guarded.
 */
const KEY = 'daevio_analysis_owner_tokens';

export interface OwnedTest {
  token: string;
  projectId: string | null;
  testId: string | null;
}

function readAll(): Record<string, OwnedTest> {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as unknown) : {};
    if (!parsed || typeof parsed !== 'object') return {};
    // Entries written before the projects were known are a bare token.
    return Object.fromEntries(
      Object.entries(parsed as Record<string, unknown>).map(([slug, v]) => [slug, typeof v === 'string' ? { token: v, projectId: null, testId: null } : (v as OwnedTest)]),
    );
  } catch {
    return {};
  }
}

export function ownedTest(slug: string): OwnedTest | null {
  return readAll()[slug] ?? null;
}
